var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "termsTitle"
  }, "Terms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "termsTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1.75 L13.125,1.75 C13.6082492,1.75 14,2.14175084 14,2.625 L14,12.25 C14,13.2164983 13.2164983,14 12.25,14 C11.2835017,14 10.5,13.2164983 10.5,12.25 L10.5,0.875 C10.5,0.391750844 10.1082492,0 9.625,0 L0.875,0 C0.391750844,0 0,0.391750844 0,0.875 L0,11.375 C0,12.8247475 1.17525253,14 2.625,14 L12.25,14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 6,
    y1: 3.5,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 6,
    y1: 6.5,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 6,
    y1: 10.5,
    y2: 10.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTerms);
export default __webpack_public_path__ + "static/media/mobile_terms.d409a5211553d265af1941b8589407ef.svg";
export { ForwardRef as ReactComponent };